import { useState } from "react";
import { H3, Label } from "../Text";
import { toast } from "react-toastify";
import Circle from "../Animation/Circle";
import { Button } from "../Buttons";
import { Request } from "../../hooks/Request";
import TableComplete from "../Tables/TableComplete";
import { requestAuth } from "../services/RequestService";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../Modal";

/**
 * Tipo: subDataFacturaAdd
 * Label UI: "Lista de facturas (adición)"
 *
 * Campos del formulario / tabla:
 *  - Label       -> Nro de Factura
 *  - Description -> Estado
 *  - Observation -> Observación
 *
 * Reutiliza el mismo endpoint de subdata que "Campo con valor multiple (adición)"
 * NO modifica el tipo subDataAdd existente.
 */
const InputSubDataFacturaAdd = ({ field }) => {
  const { openDialog, dialogClose } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
  });

  function handleForm(item) {
    openDialog(
      <>
        <FormAddFactura
          item={item}
          reload={call}
          field={field}
          onClose={dialogClose}
        />
        <br />
      </>
    );
  }

  function handleDelete(row) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar este item?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/dataSet/procedure/subData/${row.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  return (
    <div className="bg-gray-300/40 p-2 rounded-md">
      <Label htmlFor={field.name} className={`${field.className} my-0`}>
        {field.labelCustom ? field.labelCustom : field.label}
      </Label>

      {/* Formulario de alta / edición inline */}
      <div className="bg-gray-100 rounded-lg p-3 pt-2">
        <FormAddFactura reload={call} field={field} onClose={() => {}} />
      </div>
      <br />

      {/* Tabla de registros */}
      {!loading ? (
        <Circle />
      ) : (
        <div className="w-full">
          <TableComplete
            header={[
              {
                name: "label",
                label: "Nro de Factura",
              },
              {
                name: "description",
                label: "Estado",
              },
              {
                name: "observation",
                label: "Observación",
              },
              {
                name: "add",
                type: "action",
                label: "Opciones",
                sticky: true,
                actions: [
                  {
                    label: "Editar",
                    icon: "fas fa-edit",
                    action: handleForm,
                    color: "text-[#1d4ed8]",
                  },
                  {
                    label: "Eliminar",
                    icon: "fas fa-trash",
                    action: handleDelete,
                    color: "text-red-500",
                  },
                ],
              },
            ]}
            data={data}
          />
        </div>
      )}
    </div>
  );
};

const FormAddFactura = (props) => {
  const { item = null, reload, field, onClose } = props;

  const [values, setValues] = useState({
    Label: item?.label ? item.label : "",
    Description: item?.description ? item.description : "",
    Observation: item?.observation ? item.observation : "",
    NumberValue: item?.numberValue ? item.numberValue : 0,
  });

  async function handleSubmit() {
    if (!values.Label?.trim()) {
      toast.error("El Nro de Factura es obligatorio");
      return;
    }

    await requestAuth(
      item ? "put" : "post",
      item
        ? `/dataSet/procedure/subData/${item.id}`
        : `/dataSet/procedure/${field.id}/field/${field.fieldId}/subdata`,
      values
    )
      .then(() => {
        reload();
        onClose();
        setValues({
          Label: "",
          Description: "",
          Observation: "",
          NumberValue: 0,
        });
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  function handleChangeInp(e) {
    const { name, value } = e.target;
    setValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  // NO usar <form>: este bloque está dentro del FormDefault del trámite
  return (
    <div className="flex flex-col gap-2">
      {/* Nro de Factura */}
      <div>
        <Label className="mt-2">Nro de Factura</Label>
        <input
          value={values.Label}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="text"
          name="Label"
          placeholder="Ej: 001-001-0001234"
        />
      </div>

      {/* Estado */}
      <div>
        <Label className="mt-2">Estado</Label>
        <input
          value={values.Description}
          onChange={handleChangeInp}
          className="w-full p-2 rounded-md"
          type="text"
          name="Description"
          placeholder="Ej: Pagada, Pendiente, Anulada..."
        />
      </div>

      {/* Observación + botón Guardar */}
      <div>
        <Label className="mt-2">Observación</Label>
        <div className="flex gap-2">
          <input
            value={values.Observation}
            onChange={handleChangeInp}
            className="w-full p-2 rounded-md"
            type="text"
            name="Observation"
            placeholder="Observación..."
          />
          <Button
            type="button"
            typeBtn="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleSubmit();
            }}
            className="px-3 py-0"
          >
            Guardar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default InputSubDataFacturaAdd;